import { render, staticRenderFns } from "./AreaSocio.vue?vue&type=template&id=12d1cc9e&scoped=true"
import script from "./AreaSocio.vue?vue&type=script&lang=js"
export * from "./AreaSocio.vue?vue&type=script&lang=js"
import style0 from "./AreaSocio.vue?vue&type=style&index=0&id=12d1cc9e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12d1cc9e",
  null
  
)

export default component.exports